module.exports = __webpack_public_path__ + "dist/img/retail.72d34498.png";